/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Lot_AvailableInputs */

const vi_sl_lot_available = /** @type {(inputs: Sl_Lot_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KL khả dụng`)
};

/**

* @param {Sl_Lot_AvailableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_lot_available = /** @type {((inputs?: Sl_Lot_AvailableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Lot_AvailableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_lot_available(inputs)
});